import React from 'react';
import { ButtonCard } from './ButtonCard';

export interface ButtonItem {
  icon?: string;
  name: string | number;
  text: string;
}

interface ButtonProps {
  buttons: ButtonItem[];
  onClick: (string) => void;
}

const gridClass = (count: number) => {
  if (count === 1) return 'max-w-[220px] grid-cols-1';
  if (count === 3) return 'max-w-[440px] grid-cols-2 sm:max-w-[660px] sm:grid-cols-3';
  return 'max-w-[440px] grid-cols-2';
};

export const ButtonCardGroup: React.FC<ButtonProps> = ({ buttons, onClick }) => {
  return (
    <div className={`mx-auto grid items-stretch gap-4 ${gridClass(buttons.length)}`}>
      {buttons.map(btn => {
        return (
          <ButtonCard
            btnname={btn.name}
            icon={btn.icon}
            key={btn.name}
            onClick={() => onClick(btn.name)}
            text={btn.text}
          />
        );
      })}
    </div>
  );
};
